import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { Typography, Grid, Stack } from "@mui/material";
import { getAllApprovalList } from "../../apis";
import "../../App.css";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import RegManagerCard from "./components/RegManagerCard";
import SelectedRegManager from "./components/SelectedRegManager";
import AdminDrawer from "../../components/AdminDrawer";

const RegistrationManager = () => {
  const [request, setRequest] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getAllApprovalList();
      setRequest(result.data.userInfo);
      setLoading(false);
    };

    fetchData();
  }, []);

  const HandleOnClick = (id) => {
    const filteredResult = request.filter(
      (item) => item.serviceProviderInfo.serviceProviderId == id
    );
    setSelectedRequest(filteredResult[0]);
  };

  const fetchNewData = async () => {
    const result = await getAllApprovalList();
    setRequest(result.data.userInfo);
    setLoading(false);
    setSelectedRequest(null);
  };
  return (
    <>
      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="Registration Manager" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={5}>
                <Typography className="mb-16" variant="h6">
                  Service Provider Approval List
                </Typography>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {request.length && loading == false ? (
                      request.map((item) => (
                        <>
                          <RegManagerCard
                            fullName={item.serviceProvider.fullName}
                            category={
                              item.serviceProviderInfo.expertise.category
                            }
                            subCategory={
                              item.serviceProviderInfo.expertise.subCategory
                            }
                            id={item.serviceProvider._id}
                            clickHandler={HandleOnClick}
                          />
                        </>
                      ))
                    ) : request.length == 0 && loading == false ? (
                      <>
                        <Typography>No Service Provider Requests</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
              <Grid item sm={7}>
                {selectedRequest != null ? (
                  <SelectedRegManager
                    currentRequestDetails={selectedRequest}
                    handleFetchNewData={fetchNewData}
                  />
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default RegistrationManager;
